export enum NotificationChannel {
  None = 0,
  App = 1,
  Email = 2,
  Teams = 3,
}

export enum TenantSettingsKey {
  StepExecutionAppNotificationEnabled = 1,
  StepExecutionEmailNotificationEnabled = 2,
  StepExecutionTeamsNotificationEnabled = 3,
  StepExecutionTeamsNotificationWebhook = 4
}

export interface UpdateTenantViewModel {
  tenantSettingsKeyId: TenantSettingsKey,
  value: boolean | string
}

export interface TenantSettingsViewModel {
  tenantId: string;
  tenantSettingsKeyId: TenantSettingsKey;
  value: boolean | string;
}

export interface TenantNotificationSettings {
  enabledChannels: NotificationChannel[];
  teamsWebhookUrl: string;
}

export interface UpsertTenantSettingsPayload {
  channels: NotificationChannel[];
  teamsWebhookUrl: string;
}